import { useEffect, useState } from "react";
import { ActivePageType, IMeal } from "./types/types";
import { MealTabs } from "./components/Tabs";
import { Cart } from "./components/Cart";
import { ShoppingList } from "./components/ShoppingList";
import { Navigation } from "./components/BottomNavigation";
import { Settings } from "./components/Settings";
import { useCart } from "./hooks/useCart";
import { Spinner } from "./components/spinner/Spinner";
import { useShoppingList } from "./hooks/useShoppingList";
import { useMenu } from "./hooks/useMenu";
import { Menu } from "./components/Menu";

export default function App() {
  const { cart, setCart } = useCart();
  const { setMenu } = useMenu();
  const { list, setList, loading: listLoading } = useShoppingList();

  const [activePage, setActivePage] = useState<ActivePageType>('home');
  const [user, setUser] = useState<{ user: string, password: string }>(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : {};
  })

  const handleSetCart = async (updater: ((prev: IMeal[]) => IMeal[]) | IMeal[]) => {
    let value = cart
    if (typeof updater === "function") {
      value = updater(value);
    } else {
      value = updater;
    }

    setCart(value);
    setMenu(value);
  }


  useEffect(() => {
    localStorage.setItem("localProducts", JSON.stringify(list));
  }, [list]);

  const cartCounter = cart.reduce((total, current) => {
    return total + current.quantity!
  }, 0)

  const listCounter = list.filter((product) => !product.bought).length;

  return (
    <div style={{ minHeight: 'calc(100vh - 104px)', paddingBottom: 56 }}>
      {activePage === "home" && (
        <div style={{ padding: 0, paddingTop: 0, fontFamily: "sans-serif", background: "#f8fafc", height: '100%' }}>
          <MealTabs setCart={handleSetCart} cart={cart} />
        </div>
      )}

      {activePage === "cart" && <Cart setList={setList} setActivePage={setActivePage} />}
      {activePage === "menu" && <Menu />}
      {activePage === "list" && (listLoading ? <Spinner /> : <ShoppingList products={list} setProducts={setList} />)}
      {activePage === "settings" && <Settings user={user} setUser={setUser} />}

      <Navigation activePage={activePage} setActivePage={setActivePage} cartCounter={cartCounter} listCounter={listCounter} />
    </div>
  );
}
